<cb-dialog dialogHeading="{{ data.selectedContractTypeId > 0 ? 'Edit' : 'Add' }}  Build Type">
    <form #buildTypeForm="ngForm">
        <cb-select
            label="Lot Contract Type"
            name="contractType"
            [(ngModel)]="selectedContractTypeId"
            [required]="true"
            [options]="availableContractTypes"
            (change)="filterAvailableBuildTypes()"
        ></cb-select>
        <cb-select
            label="Build Type"
            name="buildType"
            [(ngModel)]="selectedBuildTypeId"
            [required]="true"
            [options]="availableBuildTypes"
            [disabled]="!selectedContractTypeId"
        ></cb-select>
        <cb-checkbox
            label="Default"
            name="default"
            [(ngModel)]="isDefaultPaymentBuildType"
        ></cb-checkbox>
        @if (defaultTemplate && defaultTemplate.id !== data.paymentTemplateId) {
            <cb-info-message
                [message]="
                    'Currently set as a default on ' +
                    defaultTemplate.label +
                    ' template. Setting this as default will override the existing default'
                "
                [icon]="'info_circle'"
            ></cb-info-message>
        }
    </form>
    <div actions>
        <button
            mat-raised-button
            color="primary"
            [disabled]="!selectedBuildTypeId || !selectedContractTypeId"
            (cbClick)="save()"
            [clickLimit]="1"
        >
            Save
        </button>
        <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
